/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AddressVm,
    AddressVmFromJSON,
    AddressVmFromJSONTyped,
    AddressVmToJSON,
    DeadlineStatusType,
    DeadlineStatusTypeFromJSON,
    DeadlineStatusTypeFromJSONTyped,
    DeadlineStatusTypeToJSON,
    FailureCreatorTypes,
    FailureCreatorTypesFromJSON,
    FailureCreatorTypesFromJSONTyped,
    FailureCreatorTypesToJSON,
    FailureStatusVm,
    FailureStatusVmFromJSON,
    FailureStatusVmFromJSONTyped,
    FailureStatusVmToJSON,
    NameVm,
    NameVmFromJSON,
    NameVmFromJSONTyped,
    NameVmToJSON,
    PhoneVm,
    PhoneVmFromJSON,
    PhoneVmFromJSONTyped,
    PhoneVmToJSON,
    SimpleContractorVm,
    SimpleContractorVmFromJSON,
    SimpleContractorVmFromJSONTyped,
    SimpleContractorVmToJSON,
    SimpleDictionaryVm,
    SimpleDictionaryVmFromJSON,
    SimpleDictionaryVmFromJSONTyped,
    SimpleDictionaryVmToJSON,
    SimpleFailureTypeVm,
    SimpleFailureTypeVmFromJSON,
    SimpleFailureTypeVmFromJSONTyped,
    SimpleFailureTypeVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface FailureListItemVm
 */
export interface FailureListItemVm {
    /**
     * 
     * @type {string}
     * @memberof FailureListItemVm
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof FailureListItemVm
     */
    reportedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FailureListItemVm
     */
    closedAt?: Date | null;
    /**
     * 
     * @type {AddressVm}
     * @memberof FailureListItemVm
     */
    address?: AddressVm;
    /**
     * 
     * @type {string}
     * @memberof FailureListItemVm
     */
    identifier?: string | null;
    /**
     * 
     * @type {SimpleFailureTypeVm}
     * @memberof FailureListItemVm
     */
    type?: SimpleFailureTypeVm;
    /**
     * 
     * @type {SimpleDictionaryVm}
     * @memberof FailureListItemVm
     */
    expanse?: SimpleDictionaryVm;
    /**
     * 
     * @type {string}
     * @memberof FailureListItemVm
     */
    description1?: string | null;
    /**
     * 
     * @type {SimpleDictionaryVm}
     * @memberof FailureListItemVm
     */
    nature?: SimpleDictionaryVm;
    /**
     * 
     * @type {string}
     * @memberof FailureListItemVm
     */
    description2?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FailureListItemVm
     */
    deadline?: Date;
    /**
     * 
     * @type {FailureStatusVm}
     * @memberof FailureListItemVm
     */
    status?: FailureStatusVm;
    /**
     * 
     * @type {string}
     * @memberof FailureListItemVm
     */
    stateChangeReason?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FailureListItemVm
     */
    attachedFailuresCount?: number;
    /**
     * 
     * @type {SimpleDictionaryVm}
     * @memberof FailureListItemVm
     */
    optimalDeadlineDays?: SimpleDictionaryVm;
    /**
     * 
     * @type {SimpleContractorVm}
     * @memberof FailureListItemVm
     */
    contractor?: SimpleContractorVm;
    /**
     * 
     * @type {FailureCreatorTypes}
     * @memberof FailureListItemVm
     */
    creatorType?: FailureCreatorTypes;
    /**
     * 
     * @type {string}
     * @memberof FailureListItemVm
     */
    notifierFamilyname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FailureListItemVm
     */
    notifierMiddlename?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FailureListItemVm
     */
    notifierForename?: string | null;
    /**
     * 
     * @type {PhoneVm}
     * @memberof FailureListItemVm
     */
    notifierPhone?: PhoneVm;
    /**
     * 
     * @type {string}
     * @memberof FailureListItemVm
     */
    notifierEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FailureListItemVm
     */
    comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FailureListItemVm
     */
    deviceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FailureListItemVm
     */
    deviceName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FailureListItemVm
     */
    redirectPathPostfix1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FailureListItemVm
     */
    redirectPathPostfix2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FailureListItemVm
     */
    deviceExternalId?: string | null;
    /**
     * 
     * @type {DeadlineStatusType}
     * @memberof FailureListItemVm
     */
    deadlineStatus?: DeadlineStatusType;
    /**
     * 
     * @type {string}
     * @memberof FailureListItemVm
     */
    parentId?: string | null;
    /**
     * 
     * @type {NameVm}
     * @memberof FailureListItemVm
     */
    creator?: NameVm;
    /**
     * 
     * @type {NameVm}
     * @memberof FailureListItemVm
     */
    modifier?: NameVm;
    /**
     * 
     * @type {Date}
     * @memberof FailureListItemVm
     */
    modifiedDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof FailureListItemVm
     */
    createdDate?: Date;
    /**
     * 
     * @type {Array<NameVm>}
     * @memberof FailureListItemVm
     */
    repairmen?: Array<NameVm> | null;
    /**
     * 
     * @type {boolean}
     * @memberof FailureListItemVm
     */
    acceptedByContractor?: boolean;
}

export function FailureListItemVmFromJSON(json: any): FailureListItemVm {
    return FailureListItemVmFromJSONTyped(json, false);
}

export function FailureListItemVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailureListItemVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'reportedAt': !exists(json, 'reportedAt') ? undefined : (new Date(json['reportedAt'])),
        'closedAt': !exists(json, 'closedAt') ? undefined : (json['closedAt'] === null ? null : new Date(json['closedAt'])),
        'address': !exists(json, 'address') ? undefined : AddressVmFromJSON(json['address']),
        'identifier': !exists(json, 'identifier') ? undefined : json['identifier'],
        'type': !exists(json, 'type') ? undefined : SimpleFailureTypeVmFromJSON(json['type']),
        'expanse': !exists(json, 'expanse') ? undefined : SimpleDictionaryVmFromJSON(json['expanse']),
        'description1': !exists(json, 'description1') ? undefined : json['description1'],
        'nature': !exists(json, 'nature') ? undefined : SimpleDictionaryVmFromJSON(json['nature']),
        'description2': !exists(json, 'description2') ? undefined : json['description2'],
        'deadline': !exists(json, 'deadline') ? undefined : (new Date(json['deadline'])),
        'status': !exists(json, 'status') ? undefined : FailureStatusVmFromJSON(json['status']),
        'stateChangeReason': !exists(json, 'stateChangeReason') ? undefined : json['stateChangeReason'],
        'attachedFailuresCount': !exists(json, 'attachedFailuresCount') ? undefined : json['attachedFailuresCount'],
        'optimalDeadlineDays': !exists(json, 'optimalDeadlineDays') ? undefined : SimpleDictionaryVmFromJSON(json['optimalDeadlineDays']),
        'contractor': !exists(json, 'contractor') ? undefined : SimpleContractorVmFromJSON(json['contractor']),
        'creatorType': !exists(json, 'creatorType') ? undefined : FailureCreatorTypesFromJSON(json['creatorType']),
        'notifierFamilyname': !exists(json, 'notifierFamilyname') ? undefined : json['notifierFamilyname'],
        'notifierMiddlename': !exists(json, 'notifierMiddlename') ? undefined : json['notifierMiddlename'],
        'notifierForename': !exists(json, 'notifierForename') ? undefined : json['notifierForename'],
        'notifierPhone': !exists(json, 'notifierPhone') ? undefined : PhoneVmFromJSON(json['notifierPhone']),
        'notifierEmail': !exists(json, 'notifierEmail') ? undefined : json['notifierEmail'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'deviceId': !exists(json, 'deviceId') ? undefined : json['deviceId'],
        'deviceName': !exists(json, 'deviceName') ? undefined : json['deviceName'],
        'redirectPathPostfix1': !exists(json, 'redirectPathPostfix1') ? undefined : json['redirectPathPostfix1'],
        'redirectPathPostfix2': !exists(json, 'redirectPathPostfix2') ? undefined : json['redirectPathPostfix2'],
        'deviceExternalId': !exists(json, 'deviceExternalId') ? undefined : json['deviceExternalId'],
        'deadlineStatus': !exists(json, 'deadlineStatus') ? undefined : DeadlineStatusTypeFromJSON(json['deadlineStatus']),
        'parentId': !exists(json, 'parentId') ? undefined : json['parentId'],
        'creator': !exists(json, 'creator') ? undefined : NameVmFromJSON(json['creator']),
        'modifier': !exists(json, 'modifier') ? undefined : NameVmFromJSON(json['modifier']),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'repairmen': !exists(json, 'repairmen') ? undefined : (json['repairmen'] === null ? null : (json['repairmen'] as Array<any>).map(NameVmFromJSON)),
        'acceptedByContractor': !exists(json, 'acceptedByContractor') ? undefined : json['acceptedByContractor'],
    };
}

export function FailureListItemVmToJSON(value?: FailureListItemVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'reportedAt': value.reportedAt === undefined ? undefined : (value.reportedAt.toISOString()),
        'closedAt': value.closedAt === undefined ? undefined : (value.closedAt === null ? null : value.closedAt.toISOString()),
        'address': AddressVmToJSON(value.address),
        'identifier': value.identifier,
        'type': SimpleFailureTypeVmToJSON(value.type),
        'expanse': SimpleDictionaryVmToJSON(value.expanse),
        'description1': value.description1,
        'nature': SimpleDictionaryVmToJSON(value.nature),
        'description2': value.description2,
        'deadline': value.deadline === undefined ? undefined : (value.deadline.toISOString()),
        'status': FailureStatusVmToJSON(value.status),
        'stateChangeReason': value.stateChangeReason,
        'attachedFailuresCount': value.attachedFailuresCount,
        'optimalDeadlineDays': SimpleDictionaryVmToJSON(value.optimalDeadlineDays),
        'contractor': SimpleContractorVmToJSON(value.contractor),
        'creatorType': FailureCreatorTypesToJSON(value.creatorType),
        'notifierFamilyname': value.notifierFamilyname,
        'notifierMiddlename': value.notifierMiddlename,
        'notifierForename': value.notifierForename,
        'notifierPhone': PhoneVmToJSON(value.notifierPhone),
        'notifierEmail': value.notifierEmail,
        'comment': value.comment,
        'deviceId': value.deviceId,
        'deviceName': value.deviceName,
        'redirectPathPostfix1': value.redirectPathPostfix1,
        'redirectPathPostfix2': value.redirectPathPostfix2,
        'deviceExternalId': value.deviceExternalId,
        'deadlineStatus': DeadlineStatusTypeToJSON(value.deadlineStatus),
        'parentId': value.parentId,
        'creator': NameVmToJSON(value.creator),
        'modifier': NameVmToJSON(value.modifier),
        'modifiedDate': value.modifiedDate === undefined ? undefined : (value.modifiedDate === null ? null : value.modifiedDate.toISOString()),
        'createdDate': value.createdDate === undefined ? undefined : (value.createdDate.toISOString()),
        'repairmen': value.repairmen === undefined ? undefined : (value.repairmen === null ? null : (value.repairmen as Array<any>).map(NameVmToJSON)),
        'acceptedByContractor': value.acceptedByContractor,
    };
}


